import React, { useState } from "react";

import "./commentInput.scss";

const CommentInput = (props: any) => {
  const { gigyaAccount } = props;

  const [inputText, setInputText] = useState("");

  const handleInput = (e) => setInputText(e.currentTarget.value);

  return (
    <>
      <div
        className={`m-comment-input__circle ${
          gigyaAccount?.profile?.gender === "f"
            ? "m-comment-input__circle-female"
            : gigyaAccount?.profile?.gender === "m"
            ? "m-comment-input__circle-male"
            : ""
        }`}
      >
        {gigyaAccount?.profile?.thumbnailURL ? (
          <div className="m-comment-input__circle__cover">
            <img
              className="m-comment-input__circle__cover__img"
              alt={gigyaAccount.profile.firstName}
              src={gigyaAccount.profile.thumbnailURL}
            />
          </div>
        ) : (
          `${gigyaAccount?.profile?.firstName.charAt(
            0
          )}${gigyaAccount?.profile?.lastName.charAt(0)}`
        )}
      </div>
      <input
        className="m-comment-input__input"
        type="text"
        placeholder="Comenta algo"
        maxLength={300}
        value={inputText}
        onChange={handleInput}
      />
      <p className="m-comment-input__length">{inputText.length} / 300</p>
      <i
        className={`m-comment-input__send icon-paper-plane1 ${
          inputText.length > 0 ? "m-comment-input__send--available" : ""
        }`}
      />
    </>
  );
};

export default CommentInput;
